'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.firmwares.list', [])
  .controller('FirmwaresListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/firmwares/list/index.js